export default "__VITE_ASSET__Clln$Sti__"